/* tslint:disable */
/* eslint-disable */
/**
 * OU-AAO API
 * This is a definition of Osaka University AAD Application API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: t.shinohara@mmj.ne.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Target
 */
export interface Target {
  /**
   *
   * @type {string}
   * @memberof Target
   */
  token: string
  /**
   *
   * @type {string}
   * @memberof Target
   */
  email: string
  /**
   *
   * @type {Date}
   * @memberof Target
   */
  createdAt: Date
}

export function TargetFromJSON(json: any): Target {
  return TargetFromJSONTyped(json, false)
}

export function TargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Target {
  if (json === undefined || json === null) {
    return json
  }
  return {
    token: json['token'],
    email: json['email'],
    createdAt: new Date(json['createdAt']),
  }
}

export function TargetToJSON(value?: Target | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    token: value.token,
    email: value.email,
    createdAt: value.createdAt.toISOString(),
  }
}
